<template>
<div>
  <router-view/>
</div>
</template>

<style>
/*
  Coctelea general styles,
  to override these, specify the section where its being used before
  - .section-class h1, .section-class h2 {};
 */
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #607d61;
}

h1 {
  color: #F8F4EA;
  font-family: 'Rubik', sans-serif;
}
h2, h3 {
  color: #607d61;
  font-family: 'Rubik', sans-serif;
}

p {
  color: #AFC9B0;
  font-family: 'IBM Plex Sans', sans-serif;
}
button {
  margin: 8px;
  border: none;
  border-radius: 12px;
  padding: 4px 8px;
  background-color: #AFC9B0;
  font-family: 'Red Hat Display', sans-serif;
  font-size: 18px;
  color: #F8F4EA;
}

hr {
  border: #607d61 2px solid;
  border-radius: 2px;
  max-width: 88%;
}

body {
  margin: 0;
  /*background: #AFC9B0;*/
  background-color: #AFC9B0;
  background-image: url('data:image/svg+xml,<svg id="visual" viewBox="0 0 2000 900" width="2000" height="900" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"><rect x="0" y="0" width="2000" height="900" fill="%23AFC9B0"></rect><path d="M0 277L47.7 282.7C95.3 288.3 190.7 299.7 285.8 305.2C381 310.7 476 310.3 571.2 299C666.3 287.7 761.7 265.3 857 257.7C952.3 250 1047.7 257 1143 266C1238.3 275 1333.7 286 1428.8 296.7C1524 307.3 1619 317.7 1714.2 322.3C1809.3 327 1904.7 326 1952.3 325.5L2000 325L2000 0L1952.3 0C1904.7 0 1809.3 0 1714.2 0C1619 0 1524 0 1428.8 0C1333.7 0 1238.3 0 1143 0C1047.7 0 952.3 0 857 0C761.7 0 666.3 0 571.2 0C476 0 381 0 285.8 0C190.7 0 95.3 0 47.7 0L0 0Z" fill="%23607d61"></path><path d="M0 201L47.7 202.5C95.3 204 190.7 207 285.8 218.5C381 230 476 250 571.2 255.2C666.3 260.3 761.7 250.7 857 233.7C952.3 216.7 1047.7 192.3 1143 191.3C1238.3 190.3 1333.7 212.7 1428.8 226.8C1524 241 1619 247 1714.2 241.2C1809.3 235.3 1904.7 217.7 1952.3 208.8L2000 200L2000 0L1952.3 0C1904.7 0 1809.3 0 1714.2 0C1619 0 1524 0 1428.8 0C1333.7 0 1238.3 0 1143 0C1047.7 0 952.3 0 857 0C761.7 0 666.3 0 571.2 0C476 0 381 0 285.8 0C190.7 0 95.3 0 47.7 0L0 0Z" fill="%2389997d"></path><path d="M0 156L47.7 164.2C95.3 172.3 190.7 188.7 285.8 182.7C381 176.7 476 148.3 571.2 147.8C666.3 147.3 761.7 174.7 857 173.2C952.3 171.7 1047.7 141.3 1143 138.2C1238.3 135 1333.7 159 1428.8 175.7C1524 192.3 1619 201.7 1714.2 189.5C1809.3 177.3 1904.7 143.7 1952.3 126.8L2000 110L2000 0L1952.3 0C1904.7 0 1809.3 0 1714.2 0C1619 0 1524 0 1428.8 0C1333.7 0 1238.3 0 1143 0C1047.7 0 952.3 0 857 0C761.7 0 666.3 0 571.2 0C476 0 381 0 285.8 0C190.7 0 95.3 0 47.7 0L0 0Z" fill="%23b0b69e"></path><path d="M0 128L47.7 131.8C95.3 135.7 190.7 143.3 285.8 136C381 128.7 476 106.3 571.2 95.7C666.3 85 761.7 86 857 90C952.3 94 1047.7 101 1143 111.7C1238.3 122.3 1333.7 136.7 1428.8 130.5C1524 124.3 1619 97.7 1714.2 83C1809.3 68.3 1904.7 65.7 1952.3 64.3L2000 63L2000 0L1952.3 0C1904.7 0 1809.3 0 1714.2 0C1619 0 1524 0 1428.8 0C1333.7 0 1238.3 0 1143 0C1047.7 0 952.3 0 857 0C761.7 0 666.3 0 571.2 0C476 0 381 0 285.8 0C190.7 0 95.3 0 47.7 0L0 0Z" fill="%23d5d4c3"></path><path d="M0 28L47.7 36.7C95.3 45.3 190.7 62.7 285.8 61C381 59.3 476 38.7 571.2 32.8C666.3 27 761.7 36 857 43.8C952.3 51.7 1047.7 58.3 1143 62.8C1238.3 67.3 1333.7 69.7 1428.8 71.3C1524 73 1619 74 1714.2 78.3C1809.3 82.7 1904.7 90.3 1952.3 94.2L2000 98L2000 0L1952.3 0C1904.7 0 1809.3 0 1714.2 0C1619 0 1524 0 1428.8 0C1333.7 0 1238.3 0 1143 0C1047.7 0 952.3 0 857 0C761.7 0 666.3 0 571.2 0C476 0 381 0 285.8 0C190.7 0 95.3 0 47.7 0L0 0Z" fill="%23f8f4ea"></path></svg>');
  /*background-size: auto;*/
  background-repeat: no-repeat;
}
/* Fix pointer on hover default items*/
:hover {
  cursor: default;
}
/* Hide scrollbar */
::-webkit-scrollbar {
    display: none;
}
/* Forms styles */
input[type=text] {
  margin: 0 2%;
  border: none;
  height: 20px; width: 90%;
  background: #F8F4EA;
  align-items: center;
  text-align: start;
}
input[type=text]:focus {
    outline: none;
}
</style>
